import { Paper, styled } from '@mui/material';

export const Wrap = styled(Paper)(() => ({
	padding: '11px 16px',
	display: 'flex',
	justifyContent: 'space-between',

	gap: '8px',
	alignItems: 'flex-start',
	flexDirection: 'column',
}));

export const SubWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	width: '100%',
}));

export const Image = styled('img')({
	width: '64px',
	height: '26px',
	borderRadius: '4px',

	objectFit: 'cover',
});
